module.exports = __webpack_public_path__ + "static/media/movies-pashu.57c504c1.svg";